import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import {  buy, paymentIntent as getPaymentIntent } from "../api/purchase";
import { useState } from "react";
import { CART_STATES, PMT } from "../classes/Enum";
import { register } from "../api/auth";

const StripePaymentComponent = ({ user, grandTotal, setIsProcessing, setError, cart,
    shippingPaid, cartState, setCartState, onCheckoutMetaChange, customerInfo,
    setLoading, couponCode }) => {
    const stripe = useStripe();
    const elements = useElements();

    const [processing, setProcessing] = useState(false);

    const handleSubmit = async (event) => {
        if (cartState !== CART_STATES.CHECKOUT) {
            return;
        };
        event.preventDefault();
        setProcessing(true);
        setIsProcessing(true);
        setLoading(true);
        setError("");
        // checkout, if email exists, return error, procs a login display for user

        if (!stripe || !elements) {
            console.error("Stripe has not loaded.");
            setError("Stripe has not loaded.");
            setProcessing(false);
            setIsProcessing(false);
            return;
        }

        try {
            const res = await buy(
                grandTotal,
                cart,
                PMT.CARD,
                customerInfo,
                shippingPaid,
                couponCode
                );
            
            if (!res.success) {
                console.log(res);
                setError(res.error);
                return;
            }

            console.log(res.orderId);

            let orderId = res.orderId;

            const { clientSecret } = await getPaymentIntent(grandTotal, cart, orderId);
            if (!clientSecret) throw new Error("Failed to create PaymentIntent.");

            elements.submit();

            const { error, paymentIntent } = await stripe.confirmPayment({
                elements,
                clientSecret,
                confirmParams: {
                    return_url: window.location.href,
                    payment_method_data: {
                        billing_details: {
                            name: `${customerInfo.firstName} ${customerInfo.lastName}`,
                            email: customerInfo.email,
                            address: {
                                line1: customerInfo.billingAddress || customerInfo.shippingAddress || '',
                                city: customerInfo.billingSuburb || customerInfo.shippingSuburb || '',
                                postal_code: customerInfo?.billingPostcode || customerInfo.shippingPostcode || '',
                                state: customerInfo?.billingState || customerInfo.shippingState || '',
                                country: customerInfo?.billingCountry || customerInfo.shippingCountry || '',
                            }
                        }
                    }
                },
                redirect: "if_required"
            });

            if (error) {
                console.error("Stripe Payment Error:", error.message);
                setError(error.message);
                setProcessing(false);
                setIsProcessing(false);
                setLoading(false);
                return;
            }
            setCartState(CART_STATES.SUCCESS);
            onCheckoutMetaChange({orderId});
            localStorage.removeItem('cart');
        } catch (err) {
            console.error("Payment processing error:", err.message);
            setError(err.message);
        } finally {
            setLoading(false);
            setProcessing(false);
            setIsProcessing(false);
        }
    };

    return (
        <form id="payment-element-form" onSubmit={handleSubmit}>
            <PaymentElement 
            onChange={(e) => {
            onCheckoutMetaChange({ paymentFilled: e.complete });
            }}/>
        </form>
    );
};

export default StripePaymentComponent;